export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.707 2.207L13 11.914V19h2v2H9v-2h2v-5.086L3.914 21 2.5 19.586l8.5-8.5V5H5v2H3V4a1 1 0 011-1h15.086L21.293.793l1.414 1.414zM13 5v4.086L17.086 5H13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};